import * as Dialog from '@radix-ui/react-dialog';
import {clsx} from 'clsx';
import {isContainerQueryAvailable} from '../lib/container-query-with-fallback';
import {useVersion} from '../context';
import styles from './item.module.css';

type Props = {
  readonly src: string;
  readonly triggerSrc: string;
  readonly alt: string;
};

export function ImageListItem({src, triggerSrc, alt}: Props) {
  const editorVersion = useVersion();

  return (
    <li
      className={clsx(
        styles.item,
        editorVersion === '2015' && styles.item2015,
        isContainerQueryAvailable() ? styles.pressReleaseRoot : styles.screen,
      )}
    >
      <Dialog.Root>
        <Dialog.Trigger asChild>
          <button
            type='button'
            aria-label='この画像を拡大表示する'
            className={styles.button}
          >
            <img
              src={triggerSrc}
              alt={alt}
              className={styles.img}
              width={178}
              height={100}
            />
          </button>
        </Dialog.Trigger>

        <Dialog.Portal>
          <Dialog.Overlay className={styles.overlay} />
          <Dialog.Content className={styles.content}>
            <div className={styles.contentBody}>
              <Dialog.Close asChild>
                <button
                  type='button'
                  aria-label='画像を閉じる'
                  className={styles.closeButton}
                >
                  <CloseIcon />
                </button>
              </Dialog.Close>
              <img
                src={src}
                alt={alt}
                className={styles.contentImage}
                width={720}
                height={480}
              />
            </div>
          </Dialog.Content>
        </Dialog.Portal>
      </Dialog.Root>
    </li>
  );
}

function CloseIcon() {
  return (
    <svg
      aria-hidden='true'
      width='16'
      height='17'
      viewBox='0 0 16 17'
      fill='none'
    >
      <g>
        <path
          d='M2 14.5107L14 2.51074'
          stroke='white'
          strokeWidth='1.97326'
          strokeMiterlimit='1'
        />
      </g>
      <g>
        <path
          d='M2 2.50977L14 14.5098'
          stroke='white'
          strokeWidth='1.97326'
          strokeMiterlimit='1'
        />
      </g>
    </svg>
  );
}
